import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import PrivacyPolicyItem, { IPrivacyPolicyItem } from './PrivacyPolicyItem';
import PrivacyPolicyScreen from './Style';

const PrivacyPolicy: FC = () => {
    const { t } = useTranslation();
    const topics = {
        topic1: 3
    };

    const retrieveCount = (currentIndex: number) => {
        let result = 0;
        Object.entries(topics).forEach((item, index) => {
            if (index < currentIndex) {
                result += item[1];
            }
        });
        return result;
    };

    const privacyPolicyItems: IPrivacyPolicyItem[] = [
        {
            topic: 'privacyPolicy.topic7',
            topicDescription: 'privacyPolicy.topic7Description',
            startPoint: 17,
            nrOfParagraphs: 9
        },
        {
            topic: 'privacyPolicy.topic8',
            startPoint: 27,
            nrOfParagraphs: 1
        }
    ];

    return (
        <>
            <PrivacyPolicyScreen>
                <div className="title">
                    <span>{t('screenLabels.privacyPolicyLabel')}</span>
                </div>

                {[...Array(5)].map((item, index) => (
                    <div key={item}>
                        <h3 className="topic">{t(`privacyPolicy.topic${index + 1}`)}</h3>
                        <div className="content">
                            <span>
                                {t(`privacyPolicy.description${index + 1}`)}
                            </span>
                        </div>
                    </div>
                ))}

                <PrivacyPolicyItem privacyPolicyItem={
                    {
                        startPoint: 0,
                        nrOfParagraphs: 3,
                        titleLabel: 'privacyPolicy.subTopic',
                        descriptionLabel: 'privacyPolicy.subDescription'
                    }
                }
                />
                <div>
                    <h3 className="topic">{t('privacyPolicy.subTopic6')}</h3>
                    <span className="paragraphDescription">{t('privacyPolicy.subDescription6')}</span>
                </div>

                <div>
                    <div className="content">
                        {Object.entries(topics).map((topic, indexI) => (
                            <div key={topic[1]}>
                                <h4 className="subTopic">{t(`privacyPolicy.subTopic${(indexI + 1) + 6}`)}</h4>
                                {indexI === 3 && <span>{t('privacyPolicy.subTopicDescription9')}</span>}
                                {[...Array(topic[1])].map((item, index) => (
                                    <div key={item}>
                                        <h5 className="paragraph">{t(`privacyPolicy.paragraph${indexI !== 0
                                            ? (index + 1) + retrieveCount(indexI)
                                            : (index + 1)}`)}
                                        </h5>
                                        <span className="paragraphDescription">{t(`privacyPolicy.paragraphDescription${indexI !== 0
                                            ? (index + 1) + retrieveCount(indexI)
                                            : (index + 1)}`)}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        )
                        )}
                    </div>
                </div>
                {[...Array(4)].map((item, index) => (
                    <div key={item}>
                        <h3 className="topic">{t(`privacyPolicy.newTopic${index + 1}`)}</h3>
                        <div className="content">
                            <span>
                                {t(`privacyPolicy.newTopicDescription${index + 1}`)}
                            </span>
                        </div>
                    </div>
                ))}

                {privacyPolicyItems
                    .map((privacyPolicyItem) => (
                        <PrivacyPolicyItem
                            privacyPolicyItem={privacyPolicyItem}
                        />
                    ))}

            </PrivacyPolicyScreen>
        </>
    );
};

export default PrivacyPolicy;
